import { createContext, useContext, useState } from "react";

const WorkflowExecutionContext = createContext();

export const useWorkflowExecutionModals = () => {
  const context = useContext(WorkflowExecutionContext);
  if (!context) {
    throw new Error("useWorkflowExecutionModals must be used within WorkflowExecutionProvider");
  }
  return context;
};

export const WorkflowExecutionProvider = ({ children }) => {
  // Array of open workflow execution modals
  const [modals, setModals] = useState([]);

  // Open a new workflow execution modal
  const openModal = (workflow) => {
    const modalKey = `${workflow.workflow_id}-${workflow.current_stage || 1}`;

    // Check if modal already exists for this workflow/stage
    const exists = modals.find((m) => m.key === modalKey);
    if (!exists) {
      setModals((prev) => [
        ...prev,
        {
          key: modalKey,
          workflow: workflow,
          open: true,
          isMinimized: false, // Store minimize state in context
        },
      ]);
    } else {
    }
  };

  // Close a specific workflow execution modal
  const closeModal = (modalKey) => {
    setModals((prev) => prev.filter((m) => m.key !== modalKey));
  };

  // Toggle minimize state for a specific modal
  const toggleMinimize = (modalKey) => {
    setModals((prev) =>
      prev.map((m) => (m.key === modalKey ? { ...m, isMinimized: !m.isMinimized } : m))
    );
  };

  // Close all modals
  const closeAllModals = () => {
    setModals([]);
  };

  const value = {
    modals,
    openModal,
    closeModal,
    toggleMinimize,
    closeAllModals,
  };

  return (
    <WorkflowExecutionContext.Provider value={value}>{children}</WorkflowExecutionContext.Provider>
  );
};
